import { render } from "./carouselErstbeschreibungen.vue?vue&type=template&id=7c6f9a14"
import script from "./carouselErstbeschreibungen.vue?vue&type=script&lang=js"
export * from "./carouselErstbeschreibungen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__